module.exports = __webpack_public_path__ + "img/computer-login-concept-illustration_114360-7892.ffdda072.jpg";